module.exports = __webpack_public_path__ + "static/media/komponenty_pulsoksymetr.51778588.svg";